import { useEffect, useState } from 'react';
import { getTournaments } from '@/lib/api';
import type { Tournament } from '@swiss-magic/shared-types';

// Story 083 — the dashboard is now a read-only list of clickable
// summary cards; every lifecycle action moved into the tournament hub.
// This controller just loads the list.
export function useDashboardController() {
  const [tournaments, setTournaments] = useState<Tournament[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getTournaments()
      .then(setTournaments)
      .finally(() => setLoading(false));
  }, []);

  return {
    tournaments,
    loading,
  };
}
